<template>
  <Modal
    visible
    no-close-on-backdrop
    hide-footer
    size="md"
    :title="$t('meeting.change_role_modal_title')"
    header-class="font-weight-bold"
    @hide="redirect"
  >
    <b-overlay :show="overlay" no-wrap />

    <div class="buttons">
      <b-button
        size="lg"
        v-for="role in roles"
        :key="role.id"
        variant="outline-primary"
        class="w-100 button--icon justify-content-between border-secondary"
        @click="changeRole(role.id)"
      >
        {{ role.name }}
        <Icon name="arrow-left" flip-h />
      </b-button>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal/Modal";
import Icon from "@/components/Icon/Icon";
import { mapGetters } from "vuex";
import { ROUTES } from "@/constants/routeConstants";

export default {
  name: "RoleModal",
  components: { Icon, Modal },
  data() {
    return {
      overlay: false,
    };
  },
  computed: {
    ...mapGetters({ roles: "user/roles" }),
  },
  methods: {
    async changeRole(new_role) {
      this.overlay = true;
      await this.$store.dispatch("user/changeRole", new_role);
      location.reload();
    },
    redirect() {
      this.$store.commit("system/setChangeRole", false);
      this.$router.push(ROUTES.forbidden);
    },
  },
};
</script>

<style scoped></style>
